






























/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/** ----------------------------------------
    JS Modules
 ---------------------------------------- */

import { GallerySlider } from '@js/module/Gallery';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    mounted() {
        const galleryOptions = {
            amount: 4,          // amount of items
            gutter: 3,          // rem value
            max: 470,           // max height
            speed: 0.05,        // speed wrapper
            elements: {
                item: '.gallery__item',
                holder: '.gallery__wrapper'
            }
        };

        new GallerySlider(this.$refs.gallery, galleryOptions)
    }

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class Gallery extends Vue {}

